export type IconSize = 'xl'
  | 'lg'
  | 'md'
  | 'sm'
  | 'xs'
  | '2xs'
  | '3xs';

export const ICON_SIZE_MAP: Record<IconSize, string> = {
  xl: '40px',
  lg: '32px',
  md: '24px',
  sm: '20px',
  xs: '16px',
  '2xs': '12px',
  '3xs': '8px',
};
